module.exports = __webpack_public_path__ + "img/1sb_logo_v3_tablet_white.bb47f5e.png";